import image from 'src/pages/CatchGame/images/modals/tsipka.webp';
import classes from './styles.module.css';
import { NavLink } from 'react-router';
import { useRoute } from 'src/router/hooks';

export const CatchGameLink = () => {
  const { ROUTE } = useRoute();

  return (
    <NavLink to={ROUTE.CATCH_GAME.get()} className={classes.button}>
      <img
        src={image}
        alt="catch game image"
        height={30}
        width={30}
        className="w-[50px] h-auto absolute left-0 768:left-7 bottom-1"
      />
      <p className="text-end w-full text-base">Catch Easter Chick</p>
    </NavLink>
  );
};
